import React, { useState } from "react";

export default function SidebarHistoryPanel(props) {
  const {
    currentUser,
    newSessions,
    openDeleteAllModal,
    showDeleteAllModal,
    DangerModal,
    confirmDeleteAll,
    closeDeleteAllModal,
    sessions = [],
    groupSessionsByDate,
    currentSessionId,
    openSession,
    getSubjectIcon,
    lastUserQuestionSafe,
    leftFooterStyle,
    deleteSession
  } = props; 

  // Local fallback state for delete confirmation to ensure it works even if parent doesn't manage it
  const [internalConfirmingDelete, setInternalConfirmingDelete] = useState(null);
  const confirmingDelete = props.confirmingDelete !== undefined ? props.confirmingDelete : internalConfirmingDelete;
  const setConfirmingDelete = props.setConfirmingDelete || setInternalConfirmingDelete;

  const groupedSessions = (sessions && sessions.length > 0 && typeof groupSessionsByDate === "function") 
    ? groupSessionsByDate(sessions) 
    : {};

  return (
    <aside className="aa-left" aria-hidden={false} style={{ fontSize: "0.85rem" }}>
      {currentUser && (
        <div style={{ backgroundColor: "#ffffff", padding: "12px 16px", borderBottom: "1px solid #f1f5f9" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {currentUser.photoURL ? (
              <img 
                src={currentUser.photoURL} 
                alt="Profile" 
                referrerPolicy="no-referrer"
                style={{ width: "36px", height: "36px", borderRadius: "50%", objectFit: "cover" }} 
              />
            ) : (
              <div style={{ 
                width: "36px", 
                height: "36px", 
                borderRadius: "50%", 
                background: "linear-gradient(135deg, #fb923c 0%, #ea580c 100%)",
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                color: "white",
                fontSize: "0.95rem",
                fontWeight: "600",
                boxShadow: "0 2px 6px rgba(234, 88, 12, 0.15)"
              }}>
                {currentUser.displayName ? currentUser.displayName.charAt(0).toUpperCase() : "S"}
              </div>
            )}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: "0.875rem", fontWeight: "600", color: "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {currentUser.displayName || "Student"}
              </div>
              <div style={{ fontSize: "0.75rem", color: "#64748b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {currentUser.email || ""}
              </div>
            </div> 
          </div>
        </div>
      )}

      <div className="aa-sidebar-header-premium-minimal" style={{ padding: "12px 16px", display: "flex", alignItems: "center", justifyContent: "between" }}>
        <div 
            className="header-branding-icon" 
            style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "0.85rem", fontWeight: "600", color: "#475569" }}
        >
          <span className="material-icons" style={{ fontSize: "16px", color: "#64748b" }}>
            history
          </span>
          <span>History</span>
        </div>

        <div className="aa-header-actions-icons" style={{ display: "flex", gap: "6px", marginLeft: "auto" }}>
  <button 
    className="icon-action-btn primary-glow" 
    onClick={() => newSessions && newSessions()} 
    title="New Chat"
    style={{ 
      background: "#fff7ed", 
      border: "1px solid #ffedd5", 
      cursor: "pointer", 
      padding: "6px", 
      borderRadius: "6px", 
      display: "flex", 
      alignItems: "center",
      transition: "all 0.2s ease"
    }}
    onMouseEnter={(e) => e.currentTarget.style.background = "#ffedd5"}
    onMouseLeave={(e) => e.currentTarget.style.background = "#fff7ed"}
  >
    <span className="material-icons" style={{ fontSize: "18px", color: "#ea580c" }}>add_circle</span>
  </button>

  <button 
    className="icon-action-btn destructive-minimal" 
    onClick={openDeleteAllModal} 
    title="Clear All History"
    style={{ 
      background: "#fef2f2", 
      border: "1px solid #fee2e2", 
      cursor: "pointer", 
      padding: "6px", 
      borderRadius: "6px", 
      display: "flex", 
      alignItems: "center",
      transition: "all 0.2s ease"
    }}
    onMouseEnter={(e) => e.currentTarget.style.background = "#fee2e2"}
    onMouseLeave={(e) => e.currentTarget.style.background = "#fef2f2"}
  >
    <span className="material-icons" style={{ fontSize: "18px", color: "#dc2626" }}>delete_sweep</span>
  </button>
</div>

        {DangerModal && (
          <DangerModal
            open={showDeleteAllModal}
            title="Clear All History?"
            description="This will permanently remove all your academic chats. This action is irreversible."
            confirmLabel="Clear History"
            cancelLabel="Keep Chats"
            onConfirm={confirmDeleteAll}
            onCancel={closeDeleteAllModal}
          />
        )}
      </div>

      <div className="aa-history-list-premium" style={{ padding: "8px 12px", overflowY: "auto", flex: 1 }}>
        {!sessions || sessions.length === 0 ? (
          <div className="history-empty-status" style={{ fontSize: "0.8rem", color: "#94a3b8", textAlign: "center", marginTop: "24px" }}>No recent activity</div>
        ) : (
          Object.entries(groupedSessions).map(([groupName, groupSessions]) => (
            groupSessions && groupSessions.length > 0 && (
              <div key={groupName} className="aa-history-group-container" style={{ marginBottom: "16px" }}>
                <h6 className="premium-group-label-bold" style={{ fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.05em", color: "#94a3b8", margin: "0 0 6px 8px" }}>
                  <span>{groupName}</span>
                </h6>
                
                {groupSessions
                  .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
                  .map((s) => {
                    const userQuestion = lastUserQuestionSafe ? lastUserQuestionSafe(s) || "" : "";
                    const subjectIcon = getSubjectIcon ? getSubjectIcon(userQuestion) : "chat";
                    const isConfirming = confirmingDelete === s.id;

                    return (
                      <div
                        key={s.id}
                        className={`premium-session-card ${s.id === currentSessionId ? "is-active" : ""}`}
                        onClick={() => openSession && openSession(s.id)}
                        style={{
                          padding: "8px 10px",
                          borderRadius: "6px",
                          cursor: "pointer",
                          transition: "background 0.2s ease",
                          backgroundColor: s.id === currentSessionId ? "#f8fafc" : "transparent",
                          marginBottom: "2px",
                          border: s.id === currentSessionId ? "1px solid #e2e8f0" : "1px solid transparent"
                        }}
                      >
                        <div className="session-card-inner">
                          <div className="session-meta-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "4px" }}>
                            <span className="premium-date-bold" style={{ fontSize: "0.7rem", color: "#64748b", fontWeight: "500" }}>
                              {groupName === "Today" 
                                ? new Date(s.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                                : new Date(s.createdAt).toLocaleDateString([], { month: 'short', day: 'numeric' })}
                            </span>
                            
                            <button
                              type="button"
                              className={`premium-delete-btn ${isConfirming ? "is-confirming" : ""}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (isConfirming) {
                                  deleteSession && deleteSession(s.id);
                                  setConfirmingDelete(null);
                                } else {
                                  setConfirmingDelete(s.id);
                                }
                              }}
                              title={isConfirming ? "Click again to confirm" : "Delete Session"}
                              style={{
                                background: isConfirming ? "#fee2e2" : "transparent",
                                border: "none",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                padding: "2px 6px",
                                borderRadius: "4px",
                                color: isConfirming ? "#dc2626" : "#94a3b8",
                                transition: "all 0.2s ease"
                              }}
                            >
                              <span className="material-icons" style={{ fontSize: '14px' }}>
                                {isConfirming ? "done" : "delete_outline"}
                              </span>
                              {isConfirming && <span className="confirm-text" style={{ fontSize: "0.7rem", fontWeight: "600" }}>Confirm</span>}
                            </button>
                          </div>

                          <div className="session-content-preview" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <span className="material-icons icon-visible" style={{ fontSize: "14px", color: "#64748b" }}>{subjectIcon}</span>
                            <p className="preview-text-line" style={{ fontSize: "0.8rem", color: "#334155", margin: 0, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", flex: 1 }}>
                              {userQuestion || "New Discussion"}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            )
          ))
        )}
      </div>

      <div
        className={`aa-left-footer ${leftFooterStyle && leftFooterStyle.left ? "fixed" : ""}`}
        style={
          leftFooterStyle && leftFooterStyle.left
            ? {
                left: leftFooterStyle.left,
                width: leftFooterStyle.width,
                bottom: leftFooterStyle.bottom,
                zIndex: leftFooterStyle.zIndex,
                padding: "12px 16px",
                borderTop: "1px solid #f1f5f9"
              }
            : { padding: "12px 16px", borderTop: "1px solid #f1f5f9" }
        }
      >
        <div className="aa-left-footer-inner" style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "4px", fontSize: "0.75rem", textAlign: "center" }}>
          <div className="muted small">
            Crafted By{" "}
            <a 
              href="https://fftech.in" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: "#f97316", fontWeight: "600", textDecoration: "none" }}
            >
              FFT
            </a>
          </div>  
          <div className="muted small"> 
            <a 
              href="https://fftech.in/agni-tutor-privacy-policy.php" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: "#f97316", fontWeight: "600", textDecoration: "none" }}
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </aside>
  );
}